// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-3WSKT","iconTwitter":"iconTwitter-3HxcD icon-3WSKT","iconFacebook":"iconFacebook-3N-gg icon-3WSKT","title":"title-3zAGc"};